const CLEAR_USER = (state) => {
  state.user = {};
};

export default CLEAR_USER;
